export const phoneNumberValidator = (value: string, translate: CallableFunction) => {
  if (!value) {
    return translate("FORM_FIELD_VALIDATION_ERRORS.invalidUSPhoneNumber");
  }

  const sanitizedValue = value.replaceAll("-", "").replaceAll(".", "").replaceAll(" ", "").trim();

  if (!/^\d+$/.test(sanitizedValue)) {
    return translate("FORM_FIELD_VALIDATION_ERRORS.onlyNumbersAllowed");
  }

  if (sanitizedValue.length !== 10) {
    return translate("FORM_FIELD_VALIDATION_ERRORS.invalidUSPhoneNumber");
  }

  return undefined;
};

export const phoneNumberValidatorDashFormat = (value: string, translate: CallableFunction) => {
  if (value) {
    if (!/^\d{3}-\d{3}-\d{4}$/.test(value)) {
      return translate("FORM_FIELD_VALIDATION_ERRORS.incorrectFormat");
    }
  }

  return undefined;
};
